import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
	selector: 'lib-shared-button',
	imports: [NgClass],
	templateUrl: './button.component.html',
	styleUrl: './button.component.scss'
})
export class LibSharedButtonComponent {
	@Input() disabled = false;
	@Input() type = 'primary';
}
